/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  var Config = window.OletLens.Config || {};

  function normalizeSunglassesType(type) {
    if (type === 'photochromic_polarized_sunglasses') return 'photochromic_polarized';
    return type;
  }

  function getSelection() {
    var active = document.querySelector('.sunglasses-upgrade.active');
    if (!active) return null;
    var type = normalizeSunglassesType(active.getAttribute('sunglasses-type'));
    var selectedColor = active.querySelector('.color-select.selected-color');
    var color = selectedColor ? selectedColor.getAttribute('data-color') : null;
    return { type: type, color: color };
  }

  function validate() {
    var sel = getSelection();
    if (!sel) return { valid: true, errors: [] };
    if (!sel.color) return { valid: false, errors: ['Please select a color for your sunglasses.'] };
    return { valid: true, errors: [] };
  }

  function clearSelection(app, options) {
    var skipCalculate = options && options.skipCalculate;
    var all = document.querySelectorAll('.sunglasses-upgrade');
    all.forEach(function (el) {
      el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      el.querySelectorAll('.color-select').forEach(function (c) {
        c.classList.remove('selected-color');
      });
      var colorLabel = el.querySelector('.selected-color-name');
      if (colorLabel) colorLabel.textContent = 'Select color:';
    });
    if (app && typeof app.setState === 'function') {
      app.setState('sunglasses', null);
      app.setState('sunglassesColor', null);
      app.setState('sunglassesPrice', 0);
      if (!skipCalculate && typeof app.calculateTotalPrice === 'function') {
        app.calculateTotalPrice();
      }
    }
  }

  function handleSelection(element, app) {
    var alreadyActive = element.classList.contains('active');
    var all = document.querySelectorAll('.sunglasses-upgrade');

    all.forEach(function (el) {
      el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      el.querySelectorAll('.color-select').forEach(function (c) {
        c.classList.remove('selected-color');
      });
    });

    if (!alreadyActive) {
      element.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      var colorLabel = element.querySelector('.selected-color-name');
      if (colorLabel) colorLabel.textContent = 'Select color:';
    }

    if (app && typeof app.setState === 'function') {
      var selection = getSelection();
      app.setState('sunglasses', selection ? selection.type : null);
      app.setState('sunglassesColor', selection ? selection.color : null);

      var price = 0;
      if (selection) {
        price = parseFloat(element.getAttribute('option-price')) || 0;
      }
      app.setState('sunglassesPrice', price);
      app.calculateTotalPrice();
    }
  }

  function handleColorSelection(element, app) {
    var parent = element.closest('.sunglasses-upgrade');
    if (!parent) return;

    parent.querySelectorAll('.color-select').forEach(function (opt) {
      opt.classList.remove('selected-color');
    });
    element.classList.add('selected-color');

    var colorName = element.getAttribute('data-color');
    var colorLabel = parent.querySelector('.selected-color-name');
    if (colorLabel) {
      colorLabel.textContent = 'Selected: ' + (colorName ? colorName.charAt(0).toUpperCase() + colorName.slice(1) : '');
    }

    if (!parent.classList.contains('active')) {
      handleSelection(parent, app);
    }

    if (app && typeof app.setState === 'function') {
      app.setState('sunglassesColor', colorName);
    }
  }

  function updateOptions(usageType) {
    var bifocalIncompatible = (Config.ADDON_RULES && Config.ADDON_RULES.bifocal_incompatible) || [];
    var isBifocal = usageType === 'bifocals';
    var all = document.querySelectorAll('.sunglasses-upgrade');

    all.forEach(function (el) {
      var type = normalizeSunglassesType(el.getAttribute('sunglasses-type'));
      if (isBifocal && bifocalIncompatible.indexOf(type) !== -1) {
        el.style.display = 'none';
        el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      } else {
        el.style.display = '';
      }
    });
  }

  function init(app) {
    var upgrades = document.querySelectorAll('.sunglasses-upgrade');
    upgrades.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('.color-select')) return;
        handleSelection(el, app);
      });
      var colors = el.querySelectorAll('.color-select');
      colors.forEach(function (colorEl) {
        colorEl.addEventListener('click', function (e) {
          e.stopPropagation();
          handleColorSelection(colorEl, app);
        });
      });
    });
  }

  window.OletLens.SunglassesModule = {
    init: init,
    handleSelection: handleSelection,
    handleColorSelection: handleColorSelection,
    getSelection: getSelection,
    validate: validate,
    updateOptions: updateOptions,
    clearSelection: clearSelection,
  };
})();
